import { Badge } from '@qodo/design-system';
import { type AccountInfoResponse } from 'types/billing';
import { spawn } from 'utils/translations';
import { getTrialBadgeViewModel } from '../utils';

const spawnPopup = spawn('billing.popup');

interface TrialBadgeProps {
  trial: AccountInfoResponse['trial'] | undefined;
  /** Overrides the active-trial translation key (default: `trial-badge`). */
  activeKey?: string;
}

/**
 * Trial-state chip shown top-left of the popup header. Renders the active-trial
 * progress ("DAY 2 OF 14 · TRIAL", neutral) or, once the trial has lapsed, a
 * "TRIAL ENDED" badge (danger). Renders nothing when there is no trial.
 * Uppercasing is presentational; the translated string stays title-case.
 */
export const TrialBadge = ({ trial, activeKey }: TrialBadgeProps) => {
  const viewModel = getTrialBadgeViewModel(trial);

  if (!viewModel) {
    return <></>;
  }

  const translationKey =
    activeKey && trial?.active ? activeKey : viewModel.translationKey;

  return (
    <Badge
      variant={viewModel.variant}
      className="uppercase font-mono text-xs font-normal"
      size="lg"
    >
      {spawnPopup(translationKey, viewModel.interpolation)}
    </Badge>
  );
};
